const LOCALE_STORAGE_KEY = "rt.locale";

const LOCALE_LIST = [
  { value: "fr-FR", label: "Francais" },
  { value: "en-US", label: "English" },
  { value: "es-ES", label: "Espanol" },
  { value: "tr-TR", label: "Türkçe" },
  { value: "ar", label: "العربية" },
];

const RTL_LANGS = new Set(["ar"]);
const SUPPORTED = new Set(LOCALE_LIST.map((entry) => entry.value));

const NORMALIZED_MAP = {
  fr: "fr-FR",
  "fr-fr": "fr-FR",
  en: "en-US",
  "en-us": "en-US",
  es: "es-ES",
  "es-es": "es-ES",
  tr: "tr-TR",
  "tr-tr": "tr-TR",
  ar: "ar",
};

export const APP_LOCALES = LOCALE_LIST;

export function resolveLocale(input, fallback = "fr-FR") {
  const raw = String(input || "").trim().toLowerCase();
  if (!raw) return fallback;
  if (SUPPORTED.has(raw)) return raw;

  const compact = raw.replace("_", "-");
  if (SUPPORTED.has(compact)) return compact;
  if (NORMALIZED_MAP[compact]) return NORMALIZED_MAP[compact];

  const base = compact.split("-")[0];
  if (NORMALIZED_MAP[base]) return NORMALIZED_MAP[base];
  return fallback;
}

export function localeToDir(locale) {
  const normalized = resolveLocale(locale);
  const lang = normalized.split("-")[0];
  return RTL_LANGS.has(lang) ? "rtl" : "ltr";
}

export function readStoredLocale() {
  if (typeof window === "undefined") return null;
  try {
    const value = window.localStorage.getItem(LOCALE_STORAGE_KEY);
    return value ? resolveLocale(value, null) : null;
  } catch {
    return null;
  }
}

export function writeStoredLocale(locale) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(LOCALE_STORAGE_KEY, resolveLocale(locale));
  } catch {
    // ignore storage errors
  }
}

export function getBrowserLocale() {
  if (typeof navigator === "undefined") return "fr-FR";
  const candidates = Array.isArray(navigator.languages) && navigator.languages.length
    ? navigator.languages
    : [navigator.language];
  for (const candidate of candidates) {
    const normalized = resolveLocale(candidate, null);
    if (normalized) return normalized;
  }
  return "fr-FR";
}

export function getInitialLocale() {
  return resolveLocale(readStoredLocale() || getBrowserLocale());
}

export function applyLocaleToDocument(locale) {
  if (typeof document === "undefined") return;
  const normalized = resolveLocale(locale);
  const dir = localeToDir(normalized);
  const root = document.documentElement;
  if (!root) return;

  root.setAttribute("lang", normalized);
  root.setAttribute("dir", dir);
}

export function toLanguageCode(locale) {
  const normalized = resolveLocale(locale);
  return normalized.split("-")[0] || "fr";
}

export function toAuth0UiLocales(locale) {
  return toLanguageCode(locale);
}
